/* eslint-disable react/no-unescaped-entities */
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import PeopleIcon from "@mui/icons-material/People";
import { colors } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
const mock = [
  {
    title: "Bus",
    subtitle: "Arrêt de bus juste à côté du lieu du festival.",
    color: colors.yellow[700],
    icon: <DirectionsBusIcon color="yellow" />,
  },
  {
    title: "Voiture",
    subtitle: "Pour se garer parking de la barre à 10€ par jour.",
    color: colors.indigo[700],
    icon: <DirectionsCarIcon />,
  },
  {
    title: "Covoiturage",
    subtitle: "N'hésite pas à rejoindre le groupe WhatsApp en t'inscrivant au festival sur le lien google Form.",
    color: colors.blue[700],
    icon: <PeopleIcon />,
  },
];

const Advantages = () => {
  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          variant={"h4"}
          gutterBottom
          align={"center"}
          sx={{ fontWeight: 700 }}
        >
          Venir à l'ABF
        </Typography>
        <Typography variant={"h6"} component={"p"} align={"center"}>
          Quelques options pour se rendre à l'ABF
        </Typography>
      </Box>
      <Box>
        <Grid container spacing={4}>
          {mock.map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <Box
                display={"flex"}
                flexDirection={"column"}
                data-aos={"fade-up"}
                data-aos-delay={i * 100}
                data-aos-offset={100}
                data-aos-duration={600}
              >
                <Box
                  component={Avatar}
                  height={80}
                  marginBottom={2}
                  bgcolor={"transparent"}
                  color={item.color}
                  variant={"square"}
                  paddingX={0}
                  borderBottom={`2px solid ${item.color}`}
                >
                  {item.icon}
                </Box>
                <Typography
                  variant={"h5"}
                  gutterBottom
                  sx={{ fontWeight: 700 }}
                >
                  {item.title}
                </Typography>
                <Typography color="text.primary">{item.subtitle}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Advantages;
